import { render, staticRenderFns } from "./BannerTargetingOptions.vue?vue&type=template&id=2bfd7c7b&"
import script from "./BannerTargetingOptions.vue?vue&type=script&lang=js&"
export * from "./BannerTargetingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports